import "../PlayList.scss"
const Notfound = () => {
    return (
        <div className="notFoundContainer" >
            <img style={{width:"1333px"}} src="/notfound.png" alt="not found " />
        </div>
    )
}

export default Notfound;